var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powered-by-container"},[_c('div',{staticClass:"powered-by"},[_c('span',[_vm._v(_vm._s(_vm.$tI('POWERED BY'))+" ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"target":"_blank","href":"https://illustrativedna.com/"}},[_c('img',{attrs:{"src":"https://illustrativedna.com/wp-content/uploads/2020/06/illustrativedna-logo.png","height":"20px"}})])
}]

export { render, staticRenderFns }